var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import css from './style.pcss';
import getTranslations from './translations';
import { helper } from "../../common/helper";
var RTLWalenNationalKandidaten = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLWalenNationalKandidaten, _LitElement);
  function RTLWalenNationalKandidaten() {
    var _this;
    _classCallCheck(this, RTLWalenNationalKandidaten);
    _this = _callSuper(this, RTLWalenNationalKandidaten);
    _this.circ = undefined;
    _this.version = undefined;
    _this.currentCirc = 0;
    _this.currentParty = undefined;
    _this.lang = "lu";
    _this.api = "https://elec-data.rtl.lu/data/walen_national.json";
    return _this;
  }
  _createClass(RTLWalenNationalKandidaten, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLWalenNationalKandidaten.prototype), "connectedCallback", this).call(this);
      this.translations = getTranslations(this.lang);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      fetch(this.api).then(function (result) {
        return result.json();
      }).then(function (result) {
        _this2.circ = result.circonscription;
        _this2.version = result.version;
      });
    }
  }, {
    key: "_renderCandidates",
    value: function _renderCandidates() {
      var _this3 = this;
      if (typeof this.currentParty === "undefined") return '';
      var candidats, parties, party;
      parties = this.circ[this.currentCirc].parties;
      party = parties.filter(function (party) {
        return party.id === _this3.currentParty;
      });
      if (party.length > 0) candidats = party[0].candidats;
      return html(_t || (_t = _`
            <div class="wlg-candidates">
                ${0}
            </div>
        `), candidats.map(function (candidat) {
        var photo;
        if (candidat.photo) photo = `https://static.rtl.lu/walen-national-2023-assets/candidates/${candidat.id}.jpg?v=${_this3.version}`;
        return html(_t2 || (_t2 = _`
                                <div class="card candidat${0}">
                                    ${0}
                                    <div class="candidat__info">
                                        <div class="candidat__header">
                                            <h4 class="candidat__name">${0} ${0}${0}</h4>
                                            <div class="candidat__role">${0}</div>
                                        </div>
                                        ${0}
                                        ${0}
                                        ${0}
                                        ${0}
                                        ${0}
                                        ${0}
                                    </div>
                                </div>
                            `), candidat.top_candidat ? ' candidat--top' : '', candidat.photo != undefined ? html(_t3 || (_t3 = _`<div class="candidat__image"><rtl-img src="${0}" width="360" height="405"></rtl-img></div>`), photo) : '', candidat.firstname, candidat.lastname, candidat.sex ? html(_t4 || (_t4 = _` (${0})`), candidat.sex) : '', candidat.actual_role, candidat.commune ? html(_t5 || (_t5 = _`<div class="candidat__job">${0}: ${0}</div>`), _this3.translations.municipality, candidat.commune) : '', candidat.age ? html(_t6 || (_t6 = _`<div class="candidat__age">${0}: ${0} ${0}</div>`), _this3.translations.age, candidat.age, _this3.translations.years) : '', candidat.job ? html(_t7 || (_t7 = _`<div class="candidat__job">${0}: ${0}</div>`), _this3.translations.profession, candidat.job) : '', candidat.first_year ? html(_t8 || (_t8 = _`<div class="candidat__firstyear">${0}: ${0}</div>`), _this3.translations.first_candidature, candidat.first_year) : '', candidat.counter ? html(_t9 || (_t9 = _`<div class="candidat__firstyear">${0}: ${0}</div>`), _this3.translations.elections_done, candidat.counter) : '', candidat.other_actual_role ? html(_t10 || (_t10 = _`<div class="candidat__firstyear">${0}: ${0}</div>`), _this3.translations.other_actual_role, candidat.other_actual_role) : '');
      }));
    }
  }, {
    key: "_renderParties",
    value: function _renderParties() {
      var _this4 = this;
      return html(_t11 || (_t11 = _`
            <div class="wln-parties">
                ${0}
            </div>
        `), this.circ[this.currentCirc].parties.map(function (party, i) {
        return html(_t12 || (_t12 = _`<div class="wln-parties__item${0}" @click=${0}><img src="https://static.rtl.lu/walen-national-2023-assets/parties/${0}.png" width="120" /></div>`), _this4.currentParty === party.id ? ' wln-parties__item--selected' : '', function (e) {
          _this4.currentParty = party.id;
        }, party.slug);
      }));
    }
  }, {
    key: "_getCurrentParty",
    value: function _getCurrentParty() {
      var _this5 = this;
      var parties, party;
      parties = this.circ[this.currentCirc].parties;
      party = parties.filter(function (party) {
        return party.id === _this5.currentParty;
      });
      if (party.length === 0) {
        party = parties[0];
      } else {
        party = party[0];
      }
      this.currentParty = party.id;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      if (!this.circ) return html(_t13 || (_t13 = _`Loading...`));
      return html(_t14 || (_t14 = _`
            <style>${0}</style>
            <div class="wln-candidats">
                <div class="wln-candidats-nav-container">
                    <ul class="wln-candidats-nav">
                       ${0}
                    </ul>
                </div>
                ${0}
                ${0}
            </div>
        `), css, this.circ.map(function (circ, i) {
        return html(_t15 || (_t15 = _`<li class="wln-candidats-nav__item${0}" @click=${0}>${0}</li>`), _this6.currentCirc === i ? ' wln-candidats-nav__item--selected' : '', function (e) {
          _this6.currentCirc = i;
          _this6._getCurrentParty();
        }, _this6.translations[circ.slug]);
      }), this._renderParties(), this._renderCandidates());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        circ: {
          type: Array
        },
        version: {
          type: Number
        },
        currentCirc: {
          type: Number
        },
        currentParty: {
          type: Number
        },
        lang: {
          type: String
        }
      };
    }
  }]);
  return RTLWalenNationalKandidaten;
}(LitElement);
export { RTLWalenNationalKandidaten as default };
window.customElements.define('rtl-walen-national-kandidaten', RTLWalenNationalKandidaten);